/**
 * Device Storage API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Version } from './version';


export interface BootloaderVersionDto { 
    addedDeviceFeatures?: Array<BootloaderVersionDto.AddedDeviceFeaturesEnum>;
    creationDate?: string;
    deviceTypeId?: string;
    id?: string;
    officialChangelog?: string;
    otherChanges?: string;
    releaseDescription?: string;
    removedDeviceFeatures?: Array<BootloaderVersionDto.RemovedDeviceFeaturesEnum>;
    version?: Version;
}
export namespace BootloaderVersionDto {
    export const AddedDeviceFeaturesEnum = {
        RemoteCommandSetLongParameter: 'REMOTE_COMMAND_SET_LONG_PARAMETER',
        OnlyPositionShortHeaderMessageFormat: 'ONLY_POSITION_SHORT_HEADER_MESSAGE_FORMAT',
        ShortHeaderMessageFormat: 'SHORT_HEADER_MESSAGE_FORMAT',
        LegacyMessageFormat: 'LEGACY_MESSAGE_FORMAT',
        HighActivityCameraTrigger: 'HIGH_ACTIVITY_CAMERA_TRIGGER',
        BrokenSchedulePeriodLength: 'BROKEN_SCHEDULE_PERIOD_LENGTH',
        BrokenUserParameterViaRemoteCommand: 'BROKEN_USER_PARAMETER_VIA_REMOTE_COMMAND'
    } as const;
    export type AddedDeviceFeaturesEnum = typeof AddedDeviceFeaturesEnum[keyof typeof AddedDeviceFeaturesEnum];
    export const RemovedDeviceFeaturesEnum = {
        RemoteCommandSetLongParameter: 'REMOTE_COMMAND_SET_LONG_PARAMETER',
        OnlyPositionShortHeaderMessageFormat: 'ONLY_POSITION_SHORT_HEADER_MESSAGE_FORMAT',
        ShortHeaderMessageFormat: 'SHORT_HEADER_MESSAGE_FORMAT',
        LegacyMessageFormat: 'LEGACY_MESSAGE_FORMAT',
        HighActivityCameraTrigger: 'HIGH_ACTIVITY_CAMERA_TRIGGER',
        BrokenSchedulePeriodLength: 'BROKEN_SCHEDULE_PERIOD_LENGTH',
        BrokenUserParameterViaRemoteCommand: 'BROKEN_USER_PARAMETER_VIA_REMOTE_COMMAND'
    } as const;
    export type RemovedDeviceFeaturesEnum = typeof RemovedDeviceFeaturesEnum[keyof typeof RemovedDeviceFeaturesEnum];
}


export type AddedDeviceFeaturesEnum = typeof BootloaderVersionDto.AddedDeviceFeaturesEnum[keyof typeof BootloaderVersionDto.AddedDeviceFeaturesEnum];
export type RemovedDeviceFeaturesEnum = typeof BootloaderVersionDto.RemovedDeviceFeaturesEnum[keyof typeof BootloaderVersionDto.RemovedDeviceFeaturesEnum];
